<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 22:06:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refunddetail/components/RefundBtn/index.vue
-->
<template>
  <!-- 售后详情底部按钮 -->
  <div class="bot_btn border_top1px_shadow">
    <div
      v-for="(btn, index) in btnList"
      :key="index"
      class="font12 font_weight500 colo0 line-height17 btn_btn"
      @click="clickBtn(btn)"
    >
      <span v-if="btn !== '联系客服'">{{ btn }}</span>
      <pharmacist-btn v-if="btn === '联系客服'" />
    </div>
    <!-- <div class="font12 font_weight500 colo0 line-height17 btn_btn">
      撤销售后
    </div> -->
  </div>
</template>
<script>
const PharmacistBtn = () =>
  import("@/components/PharmacistBtn").then(m => m.default || m);
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    PharmacistBtn
  },
  data() {
    return {};
  },
  methods: {
    clickBtn(btn) {
      this.$emit("clickBtn", btn);
    }
  }
};
</script>

<style lang="less" scoped>
.bot_btn {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 0 12px 12px;
  display: flex;
  justify-content: flex-end;
  .btn_btn {
    padding: 8px 20px;
    margin-right: 12px;
    border-radius: 21px;
    border: 1px solid #000;
  }
}
</style>
